import React from "react";
import { Users, CalendarDays, Trophy, ShieldCheck } from "lucide-react";

const COMMUNITY_IMG =
  "https://images.unsplash.com/photo-1738523686619-1b3b5d2405ee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxjb3VwbGUlMjB3b3JraW5nJTIwb3V0JTIwZ3ltfGVufDB8fHx8MTc3NzE1ODk5Nnww&ixlib=rb-4.1.0&q=85";

const cards = [
  {
    icon: Users,
    title: "Groups",
    body: "Run with crews who share your split, schedule, and energy.",
    accent: "12 active near you",
  },
  {
    icon: CalendarDays,
    title: "Events",
    body: "Hyrox meetups, run clubs, and Saturday lift sessions.",
    accent: "This weekend",
  },
  {
    icon: Trophy,
    title: "Challenges",
    body: "30-day streaks, PR contests, partner WODs. Receipts only.",
    accent: "Active leaderboards",
  },
  {
    icon: ShieldCheck,
    title: "Trainers",
    body: "Verified coaches for one-on-one programming and accountability.",
    accent: "Vetted profiles",
  },
];

const Community = () => {
  return (
    <section
      id="community"
      data-testid="community-section"
      className="relative py-24 md:py-32 bg-[#0A0A0A]"
    >
      <div className="container mx-auto max-w-7xl px-6 md:px-10">
        <div className="max-w-3xl mb-16 md:mb-20">
          <p className="text-xs uppercase tracking-[0.3em] text-[#C6FF00] font-semibold mb-4">
            More Than Dating
          </p>
          <h2 className="font-heading text-5xl md:text-6xl lg:text-7xl text-white leading-[0.95]">
            This Is A
            <br />
            <span className="text-[#C6FF00]">Fitness Community.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 md:grid-rows-2 gap-6">
          {/* Big feature card with image */}
          <div
            data-testid="community-feature-card"
            className="md:col-span-7 md:row-span-2 relative rounded-2xl overflow-hidden border border-white/5 group min-h-[320px] md:min-h-[480px]"
          >
            <img
              src={COMMUNITY_IMG}
              alt="Fit couple in gym"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/40 to-transparent" />
            <div className="absolute inset-0 p-8 md:p-12 flex flex-col justify-end">
              <span className="text-[10px] uppercase tracking-[0.3em] text-[#C6FF00] font-semibold mb-3">
                Featured
              </span>
              <h3 className="font-heading text-4xl md:text-6xl text-white leading-[0.95]">
                Real People.
                <br />
                Real Reps.
              </h3>
              <p className="text-sm md:text-base text-neutral-300 max-w-md mt-4">
                Join sessions, host workouts, or pass the Set Test together. No filters,
                no fluff — just people who lift.
              </p>
            </div>
          </div>

          {/* Small cards stacked on the right (2x2 within col-span-5) */}
          <div className="md:col-span-5 md:row-span-2 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {cards.map((c) => {
              const Icon = c.icon;
              return (
                <div
                  key={c.title}
                  data-testid={`community-card-${c.title.toLowerCase()}`}
                  className="group relative bg-[#111111] border border-white/5 rounded-2xl p-6 hover:border-[#C6FF00]/40 transition-all duration-500"
                >
                  <div className="w-11 h-11 rounded-xl bg-[#C6FF00]/10 border border-[#C6FF00]/30 flex items-center justify-center mb-4">
                    <Icon className="text-[#C6FF00]" size={20} />
                  </div>
                  <h3 className="font-heading text-2xl text-white tracking-wide mb-2">
                    {c.title}
                  </h3>
                  <p className="text-xs text-neutral-400 leading-relaxed">{c.body}</p>
                  <div className="mt-4 text-[9px] uppercase tracking-[0.25em] text-[#C6FF00]/80 font-semibold">
                    {c.accent}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Community;
